import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";

import PropTypes from "prop-types";
import { FormLabel, FormSelect } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import FormGroup from "react-bootstrap/FormGroup";
import Row from "react-bootstrap/Row";
import Table from "react-bootstrap/Table";
import {
  AREA_FILTER_COL_KEY,
  filterRows,
  renderFilterOptions,
  STATUS_FILTER_COL_KEY
} from "../../../../../utils/FilterUtil";
import { coalesce } from "../../../../../utils/ObjectUtils";
import { sortRows } from "../../../../../utils/SortUtil";
import { pushProjectColumns } from "../ActivityMonitoringQuestion";
import SortableTableQuestionHead from "../SortableTableQuestionHead";
import SortableTableRow from "../SortableTableRow";

// FIXME: this needs re-writing -> bad react state management
const ActivityListRenderer = ({ surveyTemplate, questionAnswer, measurementFilter }) => {
  const intl = useIntl();
  const [rows, setRows] = useState(questionAnswer ? coalesce(questionAnswer.rows, []) : []);
  const [statusFilter, setStatusFilter] = useState(null);
  const [areaFilter, setAreaFilter] = useState(null);
  const [filteredRows, setFilteredRows] = useState(rows);

  const question = getActivityQuestionFromTemplate(surveyTemplate);
  pushProjectColumns(question);

  const sort = (identifier, asc) => {
    setRows(sortRows(rows, questionAnswer.answers, identifier, asc));
  };

  useEffect(() => {
    setFilteredRows((fr) => {
      if (rows !== fr) {
        return filterRows(rows, measurementFilter, statusFilter, areaFilter, questionAnswer);
      }
      return fr;
    });
  }, [rows, measurementFilter, statusFilter, areaFilter, questionAnswer]);

  const handleFilterChange = (event, filterLabel) => {
    if (filterLabel === STATUS_FILTER_COL_KEY) {
      event.target.value !== "" ? setStatusFilter(event.target.value) : setStatusFilter(null);
    } else if (filterLabel === AREA_FILTER_COL_KEY) {
      event.target.value !== "" ? setAreaFilter(event.target.value) : setAreaFilter(null);
    }
  };

  const filterFields = () => {
    return (
      <Row>
        <Col lg={4}>
          <FormGroup  className="mb-3">
            <FormLabel>{intl.formatMessage({ id: "user.surveyView.question.activity.filter.status" })}</FormLabel>
            <FormSelect
              placeholder={intl.formatMessage({ id: "user.surveyView.dropdown.choose" })}
              onChange={(event) => handleFilterChange(event, STATUS_FILTER_COL_KEY)}
              value={statusFilter ? statusFilter : ""}
            >
              {renderFilterOptions(
                question.columns.find((col) => col.name === STATUS_FILTER_COL_KEY),
                questionAnswer,
                intl
              )}
            </FormSelect>
          </FormGroup>
        </Col>
        <Col lg={4}>
          <FormGroup  className="mb-3">
            <FormLabel>{intl.formatMessage({ id: "user.surveyView.question.activity.filter.area" })}</FormLabel>
            <FormSelect
              placeholder={intl.formatMessage({ id: "user.surveyView.dropdown.choose" })}
              onChange={(event) => handleFilterChange(event, AREA_FILTER_COL_KEY)}
              value={areaFilter ? areaFilter : ""}
            >
              {renderFilterOptions(
                question.columns.find((col) => col.name === AREA_FILTER_COL_KEY),
                questionAnswer,
                intl
              )}
            </FormSelect>
          </FormGroup>
        </Col>
      </Row>
    );
  };

  return (
    <Row>
      <Col sm={12}>
        {question && (
          <>
            {filterFields()}

            <Table responsive>
              <SortableTableQuestionHead question={question} onSortRows={sort} />

              <tbody>
                {filteredRows.map((row, index) => {
                  const answers = coalesce(questionAnswer.answers, []).filter(
                    (rowAnswer) => rowAnswer.label === row.name
                  );

                  return (
                    <SortableTableRow
                      disabled
                      index={index}
                      question={question}
                      rows={filteredRows}
                      rowAnswers={answers}
                      skipFirst
                      key={index}
                      intl={intl}
                    />
                  );
                })}
              </tbody>
            </Table>
          </>
        )}
      </Col>
    </Row>
  );
};

const getActivityQuestionFromTemplate = (template) => {
  let result = {};
  template?.pages?.forEach((page) => {
    page.questions?.forEach((question) => {
      if (question.type === "activityList") {
        result = question;
      }
    });
  });
  return result;
};

ActivityListRenderer.propTypes = {
  surveyTemplate: PropTypes.object.isRequired,
  questionAnswer: PropTypes.object.isRequired,
  intl: PropTypes.object
};

export default ActivityListRenderer;
